import { render, staticRenderFns } from "./HomeInsurance.vue?vue&type=template&id=d799e374&"
import script from "./HomeInsurance.vue?vue&type=script&lang=js&"
export * from "./HomeInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports